import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { AlternativMottagningsplats } from "../../../common/alternativMottagningsplats";

export class AddKundorderradAlternativaMottagningsplatserCommand extends BasicCommand<AddKundorderradAlternativaMottagningsplatserCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<AddKundorderradAlternativaMottagningsplatserCommand>;
    kundorderradId: number;
    alternativaMottagningsplatser: AlternativMottagningsplats[];

    constructor(kundorderradId: number) {
        super("AddKundorderradAlternativaMottagningsplatserCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
